(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // Para AMD
    define([], factory);
  } else if (typeof exports === 'object') {
    // Para CommonJS/Node
    module.exports = factory();
  } else {
    // Para uso global en el navegador
    root.ncsColor = factory();
  }
}(this, function () {
  var ncsRe = /^(?:NCS|NCS\sS)\s(\d{2})(\d{2})-(N|R|G|B|Y)(\d{2})?(R|G|B|Y)?$/;

  function convert(ncs) {
    // Asegurarse de que comience con "NCS "
    if (!ncs.toUpperCase().startsWith("NCS")) {
      ncs = "NCS " + ncs;
    }
    
    ncs = ncs.trim().toUpperCase().match(ncsRe);
    if (ncs === null) return false;

    var Sn = parseInt(ncs[1], 10);
    var Cn = parseInt(ncs[2], 10);
    var C1 = ncs[3];
    var N = parseInt(ncs[4], 10) || 0;

    if (C1 !== 'N') {
      var S = (1.05 * Sn - 5.25) / 100; // Ajustado a porcentaje
      var C = Cn / 100;                // Ajustado a porcentaje
      var Ra, Ga, Ba, Rc, Gc, Bc, top, ss;

      // Extraer rojo
      if (C1 === 'Y' && N <= 60) {
        Ra = 1;
      } else if ((C1 === 'Y' && N > 60) || (C1 === 'R' && N <= 80)) {
        var x1 = (C1 === 'Y') ? (N - 60) : (N + 40);
        Ra = ((Math.sqrt(14884 - Math.pow(x1, 2))) - 22) / 100;
      } else if ((C1 === 'R' && N > 80) || (C1 === 'B')) {
        Ra = 0;
      } else if (C1 === 'G') {
        var x1 = (N - 170);
        Ra = ((Math.sqrt(33800 - Math.pow(x1, 2))) - 70) / 100;
      }

      // Extraer azul
      if (C1 === 'Y' && N <= 80) {
        Ba = 0;
      } else if ((C1 === 'Y' && N > 80) || (C1 === 'R' && N <= 60)) {
        var x2 = (C1 === 'Y') ? (N - 80) + 20.5 : (N + 20) + 20.5;
        Ba = (104 - (Math.sqrt(11236 - Math.pow(x2, 2)))) / 100;
      } else if ((C1 === 'R' && N > 60) || (C1 === 'B' && N <= 80)) {
        var x3 = (C1 === 'R') ? (N - 60) - 60 : (N + 40) - 60;
        Ba = ((Math.sqrt(10000 - Math.pow(x3, 2))) - 10) / 100;
      } else if ((C1 === 'B' && N > 80) || (C1 === 'G' && N <= 40)) {
        var x5 = (C1 === 'B') ? (N - 80) - 131 : (N + 20) - 131;
        Ba = (122 - (Math.sqrt(19881 - Math.pow(x5, 2)))) / 100;
      } else if (C1 === 'G' && N > 40) {
        Ba = 0;
      }

      // Extraer verde
      if (C1 === 'Y') {
        Ga = (85 - (17 / 20) * N) / 100;
      } else if (C1 === 'R' && N <= 60) {
        Ga = 0;
      } else if (C1 === 'R' && N > 60) {
        var x6 = (N - 60) + 35;
        Ga = (67.5 - (Math.sqrt(5776 - Math.pow(x6, 2)))) / 100;
      } else if (C1 === 'B' && N <= 60) {
        var x8 = (1 * N - 68.5);
        Ga = (6.5 + (Math.sqrt(7044.5 - Math.pow(x8, 2)))) / 100;
      } else if ((C1 === 'B' && N > 60) || (C1 === 'G' && N <= 60)) {
        Ga = 0.9;
      } else if (C1 === 'G' && N > 60) {
        var x7 = (N - 60);
        Ga = (90 - (1 / 8 * x7)) / 100;
      }

      // Saturación
      var x2 = (Ra + Ga + Ba) / 3;
      Rc = ((x2 - Ra) * (1 - C) + Ra);
      Gc = ((x2 - Ga) * (1 - C) + Ga);
      Bc = ((x2 - Ba) * (1 - C) + Ba);

      // Extraer "blackness"
      top = Math.max(Rc, Gc, Bc);
      ss = 1 / top;

      // Ajuste fino
      var fineR = 1.05, fineG = 1.00, fineB = 0.95;

      return {
        R: Math.round(Math.min(255, Math.max(0, (Rc * ss * (1 - S)) * 255 * fineR))),
        G: Math.round(Math.min(255, Math.max(0, (Gc * ss * (1 - S)) * 255 * fineG))),
        B: Math.round(Math.min(255, Math.max(0, (Bc * ss * (1 - S)) * 255 * fineB)))
      };
    } else {
      // Para N (neutro)
      var v = Math.round((1 - Sn / 100) * 255);
      return {
        R: v,
        G: v,
        B: v
      };
    }
  }

  function hexify(val) {
    return val.toString(16).length > 1 ? val.toString(16) : '0' + val.toString(16);
  }

  function toHex(RGB) {
    return ['#', hexify(RGB.R), hexify(RGB.G), hexify(RGB.B)].join('');
  }

  function toRgb(RGB) {
    return 'rgb(' + [RGB.R, RGB.G, RGB.B].join(',') + ')';
  }

  // API público
  return {
    hex: function (val) {
      return val && convert(val) ? toHex(convert(val)) : null;
    },
    rgb: function (val) {
      return val && convert(val) ? toRgb(convert(val)) : null;
    }
  };
}));